import axios from "axios";
import Config from "../../../config";

const v2_actionCreateGroup = (data) => axios({
    method: "post",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups`,
    data
});

export default v2_actionCreateGroup;
